import ThrottlingPost from "../utils/throttling-post";

const Leads = ["I", "II", "III", "AVR", "AVL", "AVF", "V1", "V2", "V3", "V4", "V5", "V6"];
class ASPCoreSignalService {
    constructor(baseUrl) {
        this.urls = {
            baseUrl,
            reqSignals: "ReqSignals"
        };

        this.dataPoster = new ThrottlingPost();
    }

    // Set res and exam ids
    setIDs(result, user, user_source, storageName, record, session_id) {
        const ind1 = result?.lastIndexOf("/");
        const ind2 = result?.lastIndexOf("\\");
        let ind = ind1 > -1 ? ind1 : ind2;
        if (ind > -1) {
            result = result.slice(ind + 1);
        }

        this.resultDir = result;
        this.user = user;

        this.user_source = user_source;
        this.storageName = storageName;
        this.record = record;
        this.session_id = session_id;
    }

    // Отослать ОДИН запросов на ВЕСЬ сигнал (есть лишние запросы)
    reqSignal = async (_start, _length) => {
        // Prepare request for all leads and post them
        const req = this._prepareSignalReq(_start, _length);
        const ans = await fetch(req).then(_resp => {
            if (_resp.ok) {
                return _resp.json();
            }
            throw new Error(`Response from ${req} is not Ok!`);
        });

        return { signal: ans };
    };

    // Prepare url for request signal all leads
    _prepareSignalReq = (_start, _length, _channel) => {
        const { user_source, storageName, record, resultDir } = this;
        const { baseUrl, reqSignals } = this.urls;

        const filters = [];
        const { baseline, _35Hz, _50Hz, spikes } = this.filters ?? {};

        if (_35Hz) filters.push("35hz");
        if (_50Hz) filters.push("50hz");
        if (baseline) filters.push("isoline");
        if (spikes) filters.push("spikes");
        const payload = {
            from: Math.floor(_start),
            to: Math.floor(_start + _length),
            filters,
            lead: Leads[_channel]
        };

        const _url = new URL(`${baseUrl}${reqSignals}`);
        if (resultDir) _url.searchParams.append("res", resultDir);
        if (storageName) _url.searchParams.append("storageName", storageName);
        if (user_source) _url.searchParams.append("sourceUser", user_source);
        if (record) _url.searchParams.append("record", record);

        return this._reqPostJSON(_url, payload);
    };

    _reqPostJSON = (url_str, payload) => {
        const url = new URL(url_str);
        url.searchParams.append("session_id", this.session_id);

        const req = new Request(url, {
            method: "POST",
            headers: {
                ...this._authHeader().headers,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        });

        req.payload = payload;
        return req;
    };

    // Simple request
    async _request(_url, _answer = "json") {
        const ans = await fetch(_url, {
            headers: {
                ...this._authHeader().headers
            }
        }).then(resp => {
            if (resp.ok) {
                if (_answer === "json") {
                    return resp.json();
                } else if (_answer === "text") {
                    return resp.text();
                }
            }
            throw new Error(`Request error. ${_url}. Response is not Ok!)`);
        });

        return ans;
    }

    // Отослать ОДИН запрос на ВЕСЬ сигнал (исключая лишние запросы)
    reqSignalThrottling = (_start, _length, _extraSignal) => {
        const reqs = [this._prepareSignalReq(_start, _length)]; //, this._prepareCmpxsReq(_start, _length)
        // Дополнительный запрос для сигнала ЭКГ ритма, который строится как скроллбар для графика 12 отведений

        if (_extraSignal) {
            const { start, length, channel } = _extraSignal;
            const req = this._prepareSignalReq(start, length, channel);
            reqs.push(req);
        }

        // Data modificator before send answer from throttling post
        const _modifyDataBeforeSendAnswer = (_data, _request) => {
            const ans = {
                lead_signals: _data[0]
                // cmpxs: {
                //     Qs: _data[1].data.timeQ || [],
                //     Ss: _data[1].data.timeQ?.map((q, i) => _data[1].data.timeS[i] - q) || []
                // }
            };

            if (_data[1]) {
                const { from, to } = _request[1].payload;
                const rhsig = _data[1][0]; // взять первое свойство объекта
                ans.rhythm_signal = rhsig;
                ans.rhythm_lastRequest = {
                    start: from,
                    length: to - from
                };
            }

            return ans;
        };

        this.dataPoster.postRequestBatch(reqs, _modifyDataBeforeSendAnswer, "json");
    };

    _authHeader = () => {
        if (this.bearerToken)
            return {
                headers: {
                    Authorization: ` Bearer ${this.bearerToken}`
                }
            };
        else
            return {
                headers: {}
            };
    };
}

export default ASPCoreSignalService;
